import { render } from "./PopupManageListForm.vue?vue&type=template&id=28b1b408&lang=true"
import script from "./PopupManageListForm.vue?vue&type=script&lang=js"
export * from "./PopupManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__